/* eslint-disable import/prefer-default-export */
export { getEnvironment } from './slices/environmentSlice';
